import TextInput from './TextInput';
import UniversitySelectInput from './UniversitySelectInput';

const UniversityWithOtherInput = ({ 
  register, 
  errors, 
  watch,
  name = "university",
  otherInputName = "other_university",
  label = "University",
  validationRules = { required: 'University is required' },
  otherValidationRules = { required: 'University name is required' }
}) => {
  const selectedValue = watch(name);

  return (
    <>
      <UniversitySelectInput
        register={register}
        errors={errors}
        name={name}
        validationRules={validationRules}
        withOtheroption={true}
      />

      {selectedValue === 'other' && (
        <TextInput
          label={label + " Name"}
          name={otherInputName}
          register={register}
          errors={errors}
          validationRules={otherValidationRules}
        />
      )}
    </>
  );
};

export default UniversityWithOtherInput;
